'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { CATEGORIES } from '@/lib/constants';
import NewsletterPopup from '@/components/common/NewsletterPopup';

export default function Header() {
  const [navOpen, setNavOpen] = useState(false);
  const [showNewsletter, setShowNewsletter] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    document.body.style.overflow = navOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [navOpen]);

  return (
    <>
    <header className="site-header">
      <div className="container">
        <div className="header-inner">
          <Link href="/" className="logo">
            <img src="/logo.png" alt="The Marquee" className="logo-icon" />
            THE MARQUEE
          </Link>

          <nav className={`main-nav ${navOpen ? 'open' : ''}`}>
            {CATEGORIES.map((cat) => (
              <Link
                key={cat.slug}
                href={`/category/${cat.slug}`}
                className={pathname === `/category/${cat.slug}` ? 'active' : ''}
                onClick={() => setNavOpen(false)}
              >
                {cat.name.toUpperCase()}
              </Link>
            ))}
            <button
              className="mobile-nav-subscribe"
              onClick={() => { setNavOpen(false); setShowNewsletter(true); }}
            >
              SUBSCRIBE
            </button>
          </nav>

          <div className="header-search">
            <Link href="/search" className="search-btn" aria-label="Search">
              🔍
            </Link>
            <button className="subscribe-btn" onClick={() => setShowNewsletter(true)}>
              SUBSCRIBE
            </button>
            <button
              className="mobile-nav-toggle"
              onClick={() => setNavOpen(!navOpen)}
              aria-label="Toggle navigation"
            >
              {navOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </div>
    </header>
    {navOpen && (
      <div className="mobile-nav-backdrop" onClick={() => setNavOpen(false)} />
    )}
    <NewsletterPopup open={showNewsletter} onClose={() => setShowNewsletter(false)} />
    </>
  );
}
